import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

// fetch
import { getSamEntityResults } from "data/fetch";

export function useSamEntitySearch(uei) {
  const [errorType, setErrorType] = useState<
    "NOT_AUTHORIZED" | "NOT_FOUND" | "SERVER_ERROR" | null
  >(null);

  const { isLoading, data, error, dataUpdatedAt } = useQuery({
    queryKey: ["sam_entity", uei],
    queryFn: () => getSamEntityResults(uei),
    gcTime: 30 * 60 * 1000, // 30 minutes in milliseconds
    staleTime: 30 * 60 * 1000, // 30 minutes in milliseconds
    refetchOnWindowFocus: false,
    enabled: Boolean(uei),
    retry: false,
    throwOnError: false,
  });

  useEffect(() => {
    if (error) {
      const status =
        (error as any)?.response?.status || (error as any)?.status || 500;
      switch (status) {
        case 403:
          setErrorType("NOT_AUTHORIZED");
          break;
        case 404:
          setErrorType("NOT_FOUND");
          break;
        case 500:
          setErrorType("SERVER_ERROR");
          break;
        default:
          setErrorType(null);
          break;
      }
    } else {
      setErrorType(null); // Clear error state when no error
    }
  }, [error]);

  return {
    data,
    isLoading,
    errorType,
    dataUpdatedAt,
  };
}